import { OrderDetailsProcessObject } from '../order-details-process-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';

export class ProcessTableObject {

  private _processId: string;
  private type: string;
  private name: string;
  private status: string;
  private diagramUrl: string;


  constructor(processId: string, type: string, name: string, status: string) {
    this._processId = processId;
    this.type = type;
    this.name = name;
    this.status = status;

    this.diagramUrl = 'http://10.100.7.99:8080/bonita/portal.js/#/admin/monitoring/' + '5123416252292221317-'
      + processId + '?diagramOnly';
  }

  public static create(): ProcessTableObject {
    return new ProcessTableObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
      StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
  }
  public getDiagramUrl(): string {
    return this.diagramUrl;
  }

  public get processId(): string {
    return this._processId;
  }

}
